export var ReservedValueStoreKeys;
(function (ReservedValueStoreKeys) {
    /**
     * Application Instance Id (UUID)
     */
    ReservedValueStoreKeys["applicationInstanceId"] = "ApplicationInstanceId";
    /**
     * The stratus user id
     * 'stratus_id' in the stratus access token
     */
    ReservedValueStoreKeys["stratusUserId"] = "StratusUserId";
    /**
     * The hpid user id
     * 'sub' in the stratus access token
     */
    ReservedValueStoreKeys["hpIdUserId"] = "HpIdUserId";
    /**
     * The wpid user id
     * 'wpid' in the stratus access token
     */
    ReservedValueStoreKeys["wpIdUserId"] = "WpIdUserId";
    /**
     * The user's program level
     *
     * - TODO: Add more detail
     */
    ReservedValueStoreKeys["userProgramLevel"] = "UserProgramLevel";
    /**
     * The currently selected printer UUID
     */
    ReservedValueStoreKeys["selectedPrinterUuid"] = "SelectedPrinterUUID";
    /**
     * The model number of the selected printer
     * For example, the selected printer in the carousel for HP Smart
     */
    ReservedValueStoreKeys["selectedPrinterModelNumber"] = "SelectedPrinterModelNumber";
})(ReservedValueStoreKeys || (ReservedValueStoreKeys = {}));
/**
 * The types of the possible errors returned when invoking the ValueStore Plugin.
 */
export var ValueStoreErrorType;
(function (ValueStoreErrorType) {
    /**
     * Invalid options were passed into the ValueStore plugin method.
     */
    ValueStoreErrorType["invalidOptions"] = "InvalidOptions";
    /**
     * Unknown error occurred while calling the ValueStore Plugin
     */
    ValueStoreErrorType["unknownError"] = "UnknownError";
})(ValueStoreErrorType || (ValueStoreErrorType = {}));
//# sourceMappingURL=valuestore.js.map